import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  MetricTable,
  sortNumeric,
  selectIcon,
  selectFormat,
  Error,
} from "./../../Utils/Utils.js";

const metric = (cell, row, rowIndex, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class VideoIntelligence extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data, creators) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "",
        style: {
          width: "120px",
          maxWidth: "120px",
          textAlign: "right",
          paddingRight: "4em",
        },
        headerAlign: "left",
        formatter: (cell, row) => (
          <div>
            {row.icon ? (
              <div>
                {row.title === "Facebook" ? "Video Views" : null}{" "}
                <img
                  src={selectIcon(row.icon)}
                  alt={row.icon}
                  width="20"
                  height="20"
                />
              </div>
            ) : (
              cell.split(":").map((d, i) => <div key={i}>{d}</div>)
            )}
          </div>
        ),
        csvFormatter: (cell) => cell.split(":").join(" "),
        sort: false,
      },
    ];
    creators.forEach((c) => {
      columns.push({
        dataField: c.creator,
        text: c.creator,
        headerFormatter: (column, columnIndex, component) => (
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <img
              src={c.thumbnail}
              alt=""
              width="40"
              height="40"
              data-tooltip-id="icon-tooltip"
              data-tooltip-html={c.creator}
            />
            {data.length &&
            data[0][column.dataField] &&
            data[0][column.dataField].direction !== "no-change" ? (
              <span style={{ marginLeft: "10px" }}> vs You</span>
            ) : null}
          </div>
        ),
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: false,
        sortFunc: sortNumeric,
      });
    });

    const defaultSorted = [
      {
        dataField: "title",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return [
      <ToolkitProvider
        key="table"
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
            classes="video-intelligence-table"
          />
        )}
      </ToolkitProvider>,
      <ReactTooltip
        key="tooltip"
        id="icon-tooltip"
        className="title-tooltip"
        place="top"
        effect="solid"
        multiline={true}
        delayHide={300}
        globalEventOff="click"
      />,
    ];
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    const tableData = data.data.map((d) => {
      const _d = {};
      _d.title = d.title;
      if (d.icon) _d.icon = d.icon;
      d.creators.forEach((c) => (_d[c.name] = c.value));
      return _d;
    });

    return <div>{this.renderTable(tableData, data.meta.thumbnails)}</div>;
  }
}

export default VideoIntelligence;
